import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'

export default class Card extends React.Component {
  render() {
    const content = this.props.content
    // console.log(content)
    return (
      <ScrollAnimation
        className="transable"
        animateIn="move-up"
        animateOnce={true}
        delay={200}
      >
        <div className="card">
          {content.image ? (
            <div
              className="image"
              style={{
                backgroundImage: `url(${content.image.sizes.hd})`,
                height: content.image_height + 'px'
              }}
            />
          ) : (
            ''
          )}
          <div
            dangerouslySetInnerHTML={{ __html: content.content }}
            className="card-content"
          />
        </div>
      </ScrollAnimation>
    )
  }
}
